/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  const cHtml = document.querySelector('html');
  const cAnnouncement = document.querySelector('.c-announcement');
  const cHeader = document.querySelector('.c-header');
  const cThemeHeader = document.querySelector('.theme__header');
  const cHeaderInner = document.querySelector('.c-header .header__inner');
  const cHeaderWrapper = document.querySelector('.header__wrapper');
  const cMainContent = document.querySelector('.main-content');
  let cAncHeight = cAnnouncement.offsetHeight;
  let cThHeight = cThemeHeader.offsetHeight;

   if (cHeader.getAttribute('data-header-transparent') === 'false') {
      cMainContent?.classList.add('c-mt-fix');
  } else {
      cMainContent?.classList.remove('c-mt-fix');
  }
  
   if (cHeader.getAttribute('data-header-transparent') === 'false' && !cHtml.classList.contains('c-top-page')) {
      cThemeHeader?.classList.add('c-position__absolute');
      cAnnouncement?.classList.add('c-bg__default');
  } else {
      cThemeHeader?.classList.remove('c-position__absolute');
      cAnnouncement?.classList.remove('c-bg__default');
  }
  
  document.documentElement.style.setProperty('--c-announcement-height', `${cAncHeight}px`);
  
  if (cHeader.getAttribute('data-header-transparent') === 'true' && cHeaderWrapper.getAttribute('data-header-sticky') === 'sticky') {
      cAnnouncement.classList.add('c-position__fixed');
  } else {
      cAnnouncement.classList.remove('c-position__fixed');
  }

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => {
      let cGetScrollY = window.scrollY;
      if (cGetScrollY > cAncHeight + cThHeight) {
        cAnnouncement.classList.add('c-announcement__anim');

        // if (cHeaderWrapper.getAttribute('data-header-sticky') === 'sticky' || cHeaderWrapper.getAttribute('data-header-sticky') === 'directional') {
        //   cAnnouncement.classList.add('c-announcement__bgchange');
        // } else {
        //   cAnnouncement.classList.remove('c-announcement__bgchange');
        // }
        
      } else {
        cAnnouncement.classList.remove('c-announcement__anim');
        // cAnnouncement.classList.remove('c-announcement__bgchange');
      }
  });
  
  document.addEventListener('theme:scroll:up', e => {
     if (cHeaderWrapper.getAttribute('data-header-sticky') === 'directional') {
      cAnnouncement.classList.add('c-position__fixed');
       
      if (cAnnouncement.classList.contains('c-announcement__anim')) {
        cAnnouncement.classList.add('c-scroll__up');
      }
       
      if (cAnnouncement.classList.contains('c-scroll__down')) {
        cAnnouncement.classList.remove('c-scroll__down');
      }
    }
  });
  
  document.addEventListener('theme:scroll:down', e => {
      if (cHeader.getAttribute('data-header-transparent') === 'false' && cHeaderWrapper.getAttribute('data-header-sticky') === 'sticky') {
          cAnnouncement.classList.add('c-position__fixed');
      } else {
          cAnnouncement.classList.remove('c-position__fixed');
      }
    
      if (cHeaderWrapper.getAttribute('data-header-sticky') === 'directional') {
      cAnnouncement.classList.remove('c-position__fixed');

        if (cAnnouncement.classList.contains('c-announcement__anim')) {
          cAnnouncement.classList.add('c-scroll__down');
        }
  
        if (cAnnouncement.classList.contains('c-scroll__up')) {
          cAnnouncement.classList.remove('c-scroll__up');
        }
      }
  });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  cHeaderInner.addEventListener('mouseover', () => {
    cHtml.classList.add('js-header__hover');
  }, false);

  cHeaderInner.addEventListener('mouseleave', () => {
    cHtml.classList.remove('js-header__hover');
  }, false);


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

 // Add To Cartセクションのフロート制御
const currentPage = window.location.pathname;

// ページが '/pages/petitlampion' の場合に実行
if (currentPage === '/pages/petitlampion') {
  function updateCartVisibility() {
    var floatAddCart = document.querySelector('.float-add-cart');
    var productInner = document.querySelector('.product__inner');
    var footer = document.querySelector('.c-footer');
    var screenWidth = window.innerWidth;

    if (screenWidth >= 768) {
      // 768px以上の場合は非表示
      floatAddCart.style.display = 'none';
    } else {
      // 768px未満の場合はスクロールに応じて表示制御
      var productInnerRect = productInner.getBoundingClientRect();
      var footerRect = footer.getBoundingClientRect();
      var windowHeight = window.innerHeight;

      // .float-add-cart が .product__inner と .c-footer の外にあるかを確認
      var isNotInProductInner = productInnerRect.bottom <= 0 || productInnerRect.top >= windowHeight;
      var isNotInFooter = footerRect.top >= windowHeight || footerRect.bottom <= 0;

      if (isNotInProductInner && isNotInFooter) {
        if (!floatAddCart.classList.contains('visible')) {
          floatAddCart.style.display = 'block'; // 表示
          setTimeout(() => {
            floatAddCart.classList.add('visible');
          }); // 少し遅らせてopacityを変更
        }
      } else {
        if (floatAddCart.classList.contains('visible')) {
          floatAddCart.classList.remove('visible');
          setTimeout(() => {
            floatAddCart.style.display = 'none'; // 非表示
          }); // アニメーションが完了するのを待ってから非表示
        }
      }
    }
  }

  window.addEventListener('scroll', updateCartVisibility);
  window.addEventListener('resize', updateCartVisibility);

  // 初回の表示状態を設定
  updateCartVisibility();
}
// Add To Cartセクションのフロート制御終わり
  
})();


/****************************************
    カスタムJSの発火
****************************************/
document.addEventListener('DOMContentLoaded', function() {
    customMvAnimTrigger();
    customNewsTrigger();
    customArrowCheckTorigger();
    customSmoothScrollTorigger();
});


/****************************************
    メインビジュアルのアニメーションJS
****************************************/
function customMvAnimTrigger() {
  if (document.querySelectorAll('.c-mainvisual__section').length) {
    customMvAnim();
  }
};

function customMvAnim() {
  let cWindowScroll = 0;
  let cWindowHeight = 0;
  let scrollPast = 0;
  let loaded = false;

  const chtml = document.querySelector('html');
  const cMvSection = document.querySelector('.c-mainvisual__section');

  window.addEventListener('load', init);
  window.addEventListener('orientationchange', scrollResize);
  window.addEventListener('load', scrollResize);
  window.addEventListener('scroll', scrollResize);
  window.addEventListener('resize', scrollResize);
  
  /*-------------------------------------
    Loading
  -------------------------------------*/
  addEventListener('load', () => {
    // setTimeout(() => {
      loaded = true;
  
      const cMvFirstSlider = document.querySelector('.c-mainvisual__slider .c-mainvisual__one:first-child');
      const cLoading = document.querySelector('.c-wloading');
  
      chtml.classList.add('js-loaded');
      cLoading?.classList.add('js-hide');
      cMvFirstSlider.classList.add('slick-smooth');
  
      scrollViewFnc();
      setTimeout(() => {
        if (cLoading) {
          cLoading.style.display = 'none';
        }
        scrollViewFnc();
      }, 100);
    // }, 500);
  });
  
  
  /*-------------------------------------
    Init
  -------------------------------------*/
  function init() {    
    let cWindowScroll = window.scrollY || document.documentElement.scrollTop;
    let cWindowHeight = window.innerHeight || document.documentElement.clientHeight;

    if (document.querySelectorAll('.c-mainvisual__section').length) {
      chtml.classList.add('c-contain__mv');
    } else {
      chtml.classList.remove('c-contain__mv');
    }
      
    if($('.c-mainvisual__slider .c-mainvisual__one').length) {
      $('.c-about__textbox').css('margin-top', cWindowHeight);
  
      const $slick = $('.c-mainvisual__slider');
      $slick.slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1500, 
        accessibility: false,
        pauseOnHover: false, 
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: 0
      })
      
      $slick.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.c-mainvisual__one').eq(nextSlide).addClass('slick-smooth');
      })
      
      $slick.on('afterChange', function(event, slick, currentSlide, nextSlide){
        let i = (currentSlide ? currentSlide : 0) + 1;
        $('.c-mainvisual__one:not(:eq('+currentSlide+'))').removeClass('slick-smooth');
      })
    }
  }
  
  
  /*-------------------------------------
    Scroll
  -------------------------------------*/
  const cAboutTextBox = document.querySelector('.c-about__textinner');
  const cMvbgBox = document.querySelector('.c-mainvisual__bgbox');
  const cAboutImgBox = document.querySelector('.c-about__imgbox');
  
  function scrollViewFnc(){
    const scrollViews = document.querySelectorAll('.is-scrollview');
    scrollViews.forEach((scrollView) => {
      if (loaded && cWindowScroll > scrollView.offsetTop - cWindowHeight * 0.9) {
        scrollView.classList.add('is-view');
      } else {
        scrollView.classList.remove('is-view');
      }
    });
  }
  
  function scrollResize(){
    cWindowScroll = window.scrollY || document.documentElement.scrollTop;
    cWindowHeight = window.innerHeight || document.documentElement.clientHeight;

    let cMvSectionHeight = cMvSection.offsetHeight;
    let cMvSectionTop = cMvSection.offsetTop;
    let cMvSectionBottom = cMvSectionHeight + cMvSectionTop;
  
    scrollViewFnc();
    
    /* Scroll check
    -------------------------------------*/
    if(cWindowScroll > 100){
      chtml.classList.add('js-onscroll');
    }else{
      chtml.classList.remove('js-onscroll');
    }

    /* About image
    -------------------------------------*/
    if (document.querySelectorAll('.c-about__textinner').length) {
      if (cWindowScroll > 1) {
        cAboutImgBox.classList.add('is-view');
      } else {
        cAboutImgBox.classList.remove('is-view');
      }
  
      let atbOffsetY = cAboutTextBox.offsetTop - window.scrollY;
      cAboutImgBox.style.transform = 'translate3d(0, ' + (atbOffsetY * 0) + 'px, 0)';
    }
    
    scrollPast = cWindowScroll;
  }
}


/****************************************
    ブログNEWSのJS
****************************************/
function setNewsItemHeight($slick) {
    let maxHeight = 0;

    $slick.find('.c-news__list').css('min-height', '');

    $slick.find('.c-news__list').each(function () {
        maxHeight = Math.max(maxHeight, $(this).outerHeight());
    });

    $slick.find('.c-news__list').css('min-height', maxHeight + 'px');

    // 高さ変更後にslickを再計算
    $slick.slick('setPosition');
}

function customNewsTrigger() {
    if (document.querySelectorAll('.c-news__section').length) {
        customNews();
    }
};

function customNews() {
    $('.c-news__section .slider').each(function() {
        const $slick = $(this);

        $slick.on('init', function() {
            setNewsItemHeight($slick);
        });

        $slick.slick({
            vertical: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: true,
            dots: false,
            prevArrow: '<button class="slide-arrow prev-arrow c-vertical__arrow"><span></span></button>',
            nextArrow: '<button class="slide-arrow next-arrow c-vertical__arrow"><span></span></button>',
        });

        $(window).on('resize', function() {
            setNewsItemHeight($slick);
        });
    });
};




/****************************************
    商品ページのスライダー矢印の非表示（スライド画像が1枚の時）
****************************************/
function customArrowCheckTorigger() {
    if (document.querySelectorAll('.product__media').length) {
        customArrowCheck();
    }
};

function customArrowCheck() {
    const cProductGridSlides = document.querySelector('.product__grid--slides');
    const cProductMedia = document.querySelectorAll('.product__media').length;
    if (cProductMedia === 1) {
      cProductGridSlides.classList.add('c-hidden-arrow');
    } else {
      cProductGridSlides.classList.remove('c-hidden-arrow');
    }
}


/****************************************
    トップへ戻るボタンJS
****************************************/
function customSmoothScrollTorigger() {
    if (document.querySelectorAll('.c-smoothscroll').length) {
        customSmoothScroll();
    }
};

function customSmoothScroll() {
    /* 商品詳細ページのRelated Products と Recently Productsセクションがajax通信のため高さの取得が遅れるため、500秒遅らせる */
    setTimeout(() => {
        let viewOffset = 100;
        const smoothScrollEl = document.querySelector('.c-smoothscroll');
    
        if (document.querySelectorAll('.c-mainvisual__section').length) {
          viewOffset = 600;
        }
      
       let footerHeight = document.querySelector('footer').offsetHeight;
       let documentHeight = document.body.clientHeight;
       let displayHeight = window.innerHeight;
      
       function viewSmoothScroll() {
           if(window.scrollY < viewOffset || window.scrollY > documentHeight - displayHeight - footerHeight) {
                smoothScrollEl.classList.remove('c-view');
            } else {
                smoothScrollEl.classList.add('c-view');
            }
       }
      
        window.addEventListener('scroll', () => { 
            viewSmoothScroll();
        });
      
        smoothScrollEl.addEventListener('click', function() {
          window.scroll({ top: 0, behavior: "smooth" });
        });
    }, 500);
}


/****************************************
    トグルメニューの開閉JS
****************************************/
$(function(){
    $('.c-toggle__title').click(function(){
        if ($(this).parent().hasClass('is-active')) {
            $(this).next('.c-toggle__next').slideUp(400, 'swing');
            $(this).parent().removeClass('is-active');
        } else {
            $(this).next('.c-toggle__next').slideDown(400, 'swing');
            $(this).parent().addClass('is-active');
        }
    });
});

$(function(){
    $('.c-toggle__title').click(function(){
        if ($(this).hasClass('is-active')) {
            $(this).children('.c-toggle__child').slideUp(400, 'swing');
            $(this).removeClass('is-active');
        } else {
            $(this).children('.c-toggle__child').slideDown(400, 'swing');
            $(this).addClass('is-active');
        }
    });
});


/****************************************
  　FAQ
****************************************/


$(document).ready(function () {
    // アコーディオンの処理
    $(".accordion_header").click(function (event) {
        event.stopPropagation();
        $(this).next(".accordion_inner").slideToggle();
        $(this).toggleClass("open");
        return false;
    });

    // アンカーリンク調整
    $('a[href^="#"]').click(function () {
        var adjust = -200;
        var speed = 500;
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top + adjust;
        $('body,html').animate({ scrollTop: position }, speed, 'swing');
        return false;
    });
});




document.addEventListener('DOMContentLoaded', function() {
    // input要素を取得
    var inputElement = document.querySelector('.bnRXif');

    // gpo-container要素を取得
    var gpoContainer = document.querySelector('.gpo-container');

    // input要素の状態変更を監視
    inputElement.addEventListener('change', function() {
        if (inputElement.checked) {
            // checkedの場合、gpo-containerを非表示にする
            gpoContainer.classList.add('hidden');
        } else {
            // checkedが外れた場合、gpo-containerを表示する
            gpoContainer.classList.remove('hidden');
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    // input要素を取得
    var inputElement = document.querySelector('.bnRXif');

    // gpo-container要素を取得
    var gpoContainer = document.querySelector('.gpo-container');

    // input要素の状態変更を監視
    inputElement.addEventListener('change', function() {
        if (inputElement.checked) {
            // checkedの場合、gpo-containerを非表示にする
            gpoContainer.classList.add('hidden');
        } else {
            // checkedが外れた場合、gpo-containerを表示する
            gpoContainer.classList.remove('hidden');
        }
    });
});



// マイページポイントプログラムの表示
//ボタンクリックイベントの処理
// ポイント履歴を表示するボタンのクリックイベント
document.getElementById('showPointhistory').addEventListener('click', function() {
  // ポイント履歴を表示
  document.getElementById('pointhistory').style.display = 'block';
});

// 閉じるボタンのクリックイベント
document.getElementById('closePointhistory').addEventListener('click', function() {
  // ポイント履歴を非表示に
  document.getElementById('pointhistory').style.display = 'none';
});



document.addEventListener("DOMContentLoaded", function () {
    // フォーム送信イベントをキャッチ
    const addToCartForm = document.querySelector("form[action='/cart/add']");
    if (addToCartForm) {
        addToCartForm.addEventListener("submit", function (event) {
            // カートの内容を取得
            fetch("/cart.js")
                .then(response => response.json())
                .then(cart => {
                    const productId = document.querySelector("input[name='id']").value; // 現在の商品ID
                    let totalQuantity = 0;

                    // カート内の商品を確認
                    cart.items.forEach(item => {
                        if (item.id.toString() === productId) {
                            totalQuantity += item.quantity;
                        }
                    });

                    // 合計が2点を超えた場合に制限
                    if (totalQuantity >= 2) {
                        event.preventDefault(); // フォーム送信をキャンセル
                        alert("一回の注文で2点までしか追加できません。");
                    }
                })
                .catch(error => console.error("カート情報の取得に失敗しました: ", error));
        });
    }
});


document.addEventListener("DOMContentLoaded", function () {
    const cartUpdateButtons = document.querySelectorAll("button[name='update']");

    if (cartUpdateButtons) {
        cartUpdateButtons.forEach(button => {
            button.addEventListener("click", function (event) {
                // カートの内容を取得
                fetch("/cart.js")
                    .then(response => response.json())
                    .then(cart => {
                        cart.items.forEach(item => {
                            if (item.quantity > 2) {
                                alert("一回の注文で2点までしか購入できません。");
                                // 数量を2にリセット
                                updateCartQuantity(item.id, 2);
                                event.preventDefault();
                            }
                        });
                    })
                    .catch(error => console.error("カート情報の取得に失敗しました: ", error));
            });
        });
    }

    // カートの数量を更新する関数
    function updateCartQuantity(itemId, quantity) {
        fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: itemId,
                quantity: quantity
            })
        })
        .then(response => {
            if (response.ok) {
                location.reload(); // ページをリロードして変更を反映
            } else {
                console.error("カートの更新に失敗しました。");
            }
        });
    }
});



